import React from "react";

const CompanyLogo = ({ src, alt, ...rest }) => <img src="/content/cm-logo-head.png" alt="company-logo" {...rest} />

export default CompanyLogo;